// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.canvas-container {
  flex: 1 1;
  background-color: var(--bg-dark);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  height: 100%;
}

.canvas-wrapper {
  position: relative;
  transition: transform 0.2s ease;
}

.pixel-canvas {
  background-color: var(--bg-canvas);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  image-rendering: pixelated;
  image-rendering: crisp-edges;
}`, "",{"version":3,"sources":["webpack://./src/components/Canvas.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,0BAA0B;EAC1B,4BAA4B;AAC9B","sourcesContent":[".canvas-container {\n  flex: 1;\n  background-color: var(--bg-dark);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: auto;\n  height: 100%;\n}\n\n.canvas-wrapper {\n  position: relative;\n  transition: transform 0.2s ease;\n}\n\n.pixel-canvas {\n  background-color: var(--bg-canvas);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n  image-rendering: pixelated;\n  image-rendering: crisp-edges;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
